import { Pagination } from '@mui/material';
import styled from 'styled-components';

const CustomPagination = styled(Pagination)`
  margin: 0;
  .MuiPagination-ul {
    justify-content: center;
  }
`;

export default CustomPagination;
